'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

cbInteger.$inject = ['ValidationService'];


var _module = _angular2.default.module('cb.Integer', []);

_module.directive('cbInteger', cbInteger);

exports.default = _module;

/**
 * cb-integer (use with type="text" instead of type="number")
 *
 * Sets error 'integer' if it can't be parsed as an integer.
 *
 */

function cbInteger(ValidationService) {
    return {
        restrict: 'A',
        require: 'ngModel',
        priority: 1000,
        link: function link(scope, element, attrs, ngModel) {

            function validator(value) {
                if (ngModel.$isEmpty(value)) {
                    return true;
                }

                return ValidationService.validateInteger(value);
            }

            ngModel.$validators['integer'] = validator;
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/forms/integer/cb-integer.directive.js
// module id = 789
// module chunks = 0